import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "../PageNotFound/styles.css";

// import { withStyles } from '@material-ui/core'
// import styles from './styles.js'

class PageNotFound extends React.Component {
  render() {
    // const { classes } = this.props
    return (
      <Fragment>
        <div className="not-found">
          <h1>404: PAGE NOT FOUND</h1>
          <Link to="/register">Go Back Home</Link>
        </div>
      </Fragment>
    );
  }
}

export default PageNotFound;
